import React, { PureComponent } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import validate from '../../validate';

class WizardFormFour extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    previousPage: PropTypes.func.isRequired,
  };

  render() {
    const { handleSubmit, previousPage } = this.props;

    return (
      <form className="form form--horizontal wizard__form" onSubmit={handleSubmit}>
        <h3 className="wizard__title">Назначьте права пользователю</h3>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Field name="isAdmin" component={renderCheckBoxField} label="Этот пользователь является администратором" />
          </div>
        </div>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Field name="isCurator" component={renderCheckBoxField} label="Этот пользователь является куратором" />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" type="button" className="previous" onClick={previousPage}>
            Предыдущий шаг
          </Button>
          <Button color="primary" type="submit" className="next">
            Следующий шаг
          </Button>
        </ButtonToolbar>
      </form>
    );
  }
}

export default reduxForm({
  form: 'users_create_form',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WizardFormFour);
